import {
  IFilterConfig,
  FilterTypeEnum,
  TFilterPropsItem,
  TFilterValue,
} from "@unlimint/admin-ui-kit"

import { dateToUTCTimestamp, timestampNow } from "domain/core/utils"
import { mapDictionaryToFilterMultiChoice } from "domain/globalConfig/dictionary/mappers"
import { TDictionaryList } from "domain/globalConfig/dictionary/types"

import { TTransactionsFilterReq } from "./types"

export const mapToTransactionFilterReq = (
  filters: IFilterConfig
): TTransactionsFilterReq => {
  if (!filters) return {}

  const res = filters.items.reduce((acc, item) => {
    if (!item.value) return acc

    if (item.type === FilterTypeEnum.String) {
      acc[item.field] = item.value
    }

    if (item.type === FilterTypeEnum.Amount) {
      acc[item.field] = {
        from: item.value.from ? +item.value.from : undefined,
        to: item.value.to ? +item.value.to : undefined,
      }
    }

    if (item.type === FilterTypeEnum.DateRange) {
      acc[item.field] = {
        from: item.value.start
          ? dateToUTCTimestamp(item.value.start)
          : dateToUTCTimestamp("2000-01-01T00:00:00"),
        to: item.value.end
          ? dateToUTCTimestamp(item.value.end)
          : timestampNow(),
      }
    }

    if (item.type === FilterTypeEnum.MultiChoice) {
      acc[item.field] = item.value.reduce((accVal, val) => {
        if (val.checked) accVal.push(val.name)
        return accVal
      }, [])
    }

    return acc
  }, {})

  return res
}

export const mergeDictionariesWithFilters = (
  filters: TFilterPropsItem<TFilterValue>[],
  dictionaries: TDictionaryList
) => {
  return filters.map((item) => {
    if (item.field === "status") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.transactionStatuses
      )
    }

    if (item.field === "cardBrand") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.paymentSystemSubmethods
      )
    }

    if (item.field === "operation") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.operations
      )
    }

    if (item.field === "paymentSystemStatus") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.paymentSystemStatuses
      )
    }

    if (item.field === "country") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.countries
      )
    }

    if (item.field === "countryOfResidence") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.countries
      )
    }

    if (item.field === "cardIssuingCountry") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.countries
      )
    }

    if (item.field === "paymentMethod") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.paymentMethods
      )
    }

    if (item.field === "clientPayCurrency") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.currencies
      )
    }

    if (item.field === "clientGetCurrency") {
      item.defaultValue = mapDictionaryToFilterMultiChoice(
        dictionaries.cryptoAssets
      )
    }

    return item
  })
}
